import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../types';
import { SystemChangeHistoryState, SystemChangeHistory, SystemChangeHistorySearchResult } from './types';
import * as types from './mutation-types';

const startCommon = (status): void => {
    status.error = false;
    status.errorCode = undefined;
    status.errorMsg = undefined;
    status.isProcessing = true;
    status.isFetchSuccess = false;
};
const successCommon = (status): void => {
    status.isProcessing = false;
    status.isFetchSuccess = true;
};
const failureCommon = (status, payload: { code: string; message: string }): void => {
    status.errorCode = payload.code;
    status.errorMsg = payload.message;
    status.error = true;
    status.isProcessing = false;
    status.isFetchSuccess = false;
};

// 検索のエラーをクリアする
const resetAllErrors = (state: SystemChangeHistoryState): void => {
    const userState = state.user;
    userState.error = false;
    userState.errorCode = undefined;
    userState.errorMsg = undefined;

    const mailState = state.mail;
    mailState.error = false;
    mailState.errorCode = undefined;
    mailState.errorMsg = undefined;

    const nodeState = state.node;
    nodeState.error = false;
    nodeState.errorCode = undefined;
    nodeState.errorMsg = undefined;

    const systemSettingState = state.systemSetting;
    systemSettingState.error = false;
    systemSettingState.errorCode = undefined;
    systemSettingState.errorMsg = undefined;

    const accountInventorySettingState = state.accountInventorySetting;
    accountInventorySettingState.error = false;
    accountInventorySettingState.errorCode = undefined;
    accountInventorySettingState.errorMsg = undefined;

    const csvState = state.csv;
    csvState.error = false;
    csvState.errorCode = undefined;
    csvState.errorMsg = undefined;
};

export const mutations: MutationTree<SystemChangeHistoryState> = {
    // 検索系
    [types.USER_START](state) {
        resetAllErrors(state);
        startCommon(state.user);
    },

    [types.USER_SUCCESS](state, payload: { count: number; system_change_histories: Array<SystemChangeHistory> }) {
        state.userResult = { historyCount: payload.count, histories: payload.system_change_histories };
        successCommon(state.user);
    },

    [types.USER_FAILURE](state, payload: { code: string; message: string }) {
        failureCommon(state.user, payload);
    },

    [types.MAIL_START](state) {
        resetAllErrors(state);
        startCommon(state.mail);
    },

    [types.MAIL_SUCCESS](state, payload: { count: number; system_change_histories: Array<SystemChangeHistory> }) {
        state.mailResult = { historyCount: payload.count, histories: payload.system_change_histories };
        successCommon(state.mail);
    },

    [types.MAIL_FAILURE](state, payload: { code: string; message: string }) {
        failureCommon(state.mail, payload);
    },

    [types.NODE_START](state) {
        resetAllErrors(state);
        startCommon(state.node);
    },

    [types.NODE_SUCCESS](state, payload: { count: number; system_change_histories: Array<SystemChangeHistory> }) {
        state.nodeResult = { historyCount: payload.count, histories: payload.system_change_histories };
        successCommon(state.node);
    },

    [types.NODE_FAILURE](state, payload: { code: string; message: string }) {
        failureCommon(state.node, payload);
    },

    [types.SYSTEM_SETTING_START](state) {
        resetAllErrors(state);
        startCommon(state.systemSetting);
    },

    [types.SYSTEM_SETTING_SUCCESS](
        state,
        payload: { count: number; system_change_histories: Array<SystemChangeHistory> }
    ) {
        state.systemSettingResult = { historyCount: payload.count, histories: payload.system_change_histories };
        successCommon(state.systemSetting);
    },

    [types.SYSTEM_SETTING_FAILURE](state, payload: { code: string; message: string }) {
        failureCommon(state.systemSetting, payload);
    },

    [types.ACCOUNT_INVENTORY_START](state) {
        resetAllErrors(state);
        startCommon(state.accountInventorySetting);
    },

    [types.ACCOUNT_INVENTORY_SUCCESS](
        state,
        payload: { count: number; system_change_histories: Array<SystemChangeHistory> }
    ) {
        state.accountInventorySettingResult = {
            historyCount: payload.count,
            histories: payload.system_change_histories,
        };
        successCommon(state.accountInventorySetting);
    },

    [types.ACCOUNT_INVENTORY_FAILURE](state, payload: { code: string; message: string }) {
        failureCommon(state.accountInventorySetting, payload);
    },

    // CSV出力系
    [types.CSV_OUTPUT_START](state) {
        resetAllErrors(state);
        const csvState = state.csv;
        csvState.error = false;
        csvState.errorCode = undefined;
        csvState.errorMsg = undefined;
        csvState.isProcessing = true;
    },

    [types.CSV_OUTPUT_SUCCESS](state) {
        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CSV_OUTPUT_FAILURE](state, payload: { code: string; message: string }) {
        const csvState = state.csv;
        csvState.errorCode = payload.code;
        csvState.errorMsg = payload.message;
        csvState.error = true;
        csvState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const userState = state.user;
        userState.isProcessing = false;
        userState.isFetchSuccess = false;

        const mailState = state.mail;
        mailState.isProcessing = false;
        mailState.isFetchSuccess = false;

        const nodeState = state.node;
        nodeState.isProcessing = false;
        nodeState.isFetchSuccess = false;

        const systemSettingState = state.systemSetting;
        systemSettingState.isProcessing = false;
        systemSettingState.isFetchSuccess = false;

        const accountInventorySettingState = state.accountInventorySetting;
        accountInventorySettingState.isProcessing = false;
        accountInventorySettingState.isFetchSuccess = false;

        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetAllErrors(state);
        state.userResult.histories = undefined;
        state.userResult.historyCount = 0;
        state.mailResult.histories = undefined;
        state.mailResult.historyCount = 0;
        state.nodeResult.histories = undefined;
        state.nodeResult.historyCount = 0;
        state.systemSettingResult.histories = undefined;
        state.systemSettingResult.historyCount = 0;
        state.accountInventorySettingResult.histories = undefined;
        state.accountInventorySettingResult.historyCount = 0;
    },
};
